module.exports = __webpack_public_path__ + "img/Disponible-icon.3e52d8b0.svg";